import React from "react";
import "./styles.css";

const SkeletonHeaderIndicators: React.FC = () => {
  return (
    <div className="skeleton-header-wrapper">
      <div className="skeleton-header-top">
        <div className="skeleton-header-left">
          <div className="skeleton-circle"></div>
          <div className="skeleton-title"></div>
        </div>

        <div className="skeleton-header-right">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="skeleton-btn"></div>
          ))}
        </div>
      </div>

      <div className="skeleton-tabs">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="skeleton-tab"></div>
        ))}
      </div>
    </div>
  );
};

export default SkeletonHeaderIndicators;
